import React from 'react';
import { WheelchairCheckbox } from '../Common/WheelchairCheckbox';
import { WeatherDependence } from '../Common/WeatherDependence';
import { CostRange } from '../Common/CostRange';
import { DurationRange } from '../Common/DurationRange';

const PropertiesForm = ({ formData, setFormData, info }) => (
  <div className="modal-content properties-filter">
    <WheelchairCheckbox
      checked={formData.wheelchairAccessible}
      onCheckedChange={(checked) => setFormData('wheelchair_accessible', checked)}
      showFieldInfo
      fieldInfoText={info.wheelchairAccessible}
    />

    <WeatherDependence
      value={formData.weatherType}
      onChange={(v) => setFormData(prev => ({ ...prev, weatherType: v }))}
      fieldInfo={info.weatherType}
    />

    <CostRange
      value={formData.cost}
      onChange={(v) => setFormData(prev => ({ ...prev, cost: v }))}
      fieldInfo={info.cost}
    />

    <DurationRange
      value={formData.duration}
      onChange={(v) => setFormData(prev => ({ ...prev, duration: v }))}
      fieldInfo={info.duration}
    />
  </div>
);

export default PropertiesForm;
